// Module
var code = "<template>\n  <iframe if.bind=\"pdfUrl\" src.bind=\"pdfUrl\" style=\"width: 100%; height: 100%; border: none\"></iframe>\n</template>\n";
// Exports
export default code;